export default $(document).ready(e => {

    const segment = "input:radio[name='segment']";
    const objektart = "input:radio[name='objektart']";

    const form = $('#product_configuration_form');
    const segment_alert = $("#segment-alert");
    const objektart_alert = $("#objektart-alert");

    const objektart_container = $("#objektart");

    // hide objektart on page load
    objektart_container.addClass("d-none");

    $(segment).change(e => {
        segment_alert.addClass("d-none");
        objektart_alert.addClass("d-none");

        if (e.target.value !== "Wohnen") {
            $("#objektart").removeClass("d-none");
            objektart_container.addClass("d-none");
        } else {
            objektart_container.removeClass("d-none");
        }
    })

    // valiadte on form submit
    $("#btn_submit").click(e => {
            e.preventDefault();

            let segment_selected = $(segment + ":checked");
            let objektart_selected = $(objektart + ":checked");

            console.log("submitting form");
            console.log("segment: " + segment_selected.val());
            console.log("objektart: " + objektart_selected.val());


            function validateForm() {
                if (!segment_selected.val()) {
                    segment_alert.removeClass("d-none");
                    return false;
                }

                if (segment_selected.val() === "Wohnen") {
                    if (!objektart_selected.val() || objektart_selected.val() === "") {
                        objektart_alert.removeClass("d-none");
                        return false;
                    }
                }
                return true;
            }


            if (validateForm()) {
                console.log("form is valid");
                form.submit();
            }

        }
    )


})
